var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tinymce-box"},[_c('Editor',{key:_vm.tinymceFlag,attrs:{"init":_vm.init,"disabled":_vm.disabled},on:{"onClick":_vm.onClick},model:{value:(_vm.contentValue),callback:function ($$v) {_vm.contentValue=$$v},expression:"contentValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }